import { Badge } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconTruckDelivery } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v1/colors";
import { TransportSelectModal } from "#modules/quoteRequests/view/TransportSelectModal";
import { useQuoteRequestTransport } from "#modules/quoteRequests/view/useQuoteRequestTransport";
import classes from "#shared/view/designSystem/inputs/InputStyles.module.css";
import { Skeleton } from "#shared/view/designSystem/Skeleton";
import { formatPrice } from "shared";

export const TransportSelect = ({
  quoteRequestId,
  hasBatches,
}: {
  quoteRequestId: string;
  hasBatches: boolean;
}) => {
  const { t } = useTranslation();
  const [isOpen, { open, close }] = useDisclosure(false);

  const { quoteRequestTransport, isLoading } = useQuoteRequestTransport(quoteRequestId);

  const hasTransport = quoteRequestTransport?.hasTransport ?? false;
  const transportTotalCost = quoteRequestTransport?.totalCost ?? 0;

  if (isLoading) {
    return <Skeleton width={130} height={20} />;
  }

  return (
    <>
      <TransportSelectModal
        isOpen={isOpen}
        close={close}
        quoteRequestId={quoteRequestId}
        transportTotalCost={transportTotalCost}
        hasTransport={hasTransport}
        hasBatches={hasBatches}
      />
      <Badge
        classNames={{ root: classes.smallInputHeight }}
        radius="xs"
        color={hasTransport ? colors.green[4] : colors.gray[4]}
        leftSection={<IconTruckDelivery size={18} />}
        onClick={open}
        style={{
          cursor: "pointer",
        }}
      >
        {t("quoteRequest.transport.transport")}{" "}
        {hasTransport ? `${formatPrice(transportTotalCost)}` : ""}
      </Badge>
    </>
  );
};
